import type { Tranch } from "@/types/types";
import { RowPreparedEvent } from "devextreme/ui/data_grid";

export function calculateAwardsVestedToDate(rsu: Tranch) {
  if (!rsu.vestingDate) return 0;

  return new Date(rsu.vestingDate) <= new Date() ? rsu.options * (rsu.vestingPercentage / 100) : 0;
}

export function calculateAwardsUnvestedToDate(rsu: Tranch) {
  if (!rsu.vestingDate) return 0;

  return new Date(rsu.vestingDate) > new Date() ? rsu.options * (rsu.vestingPercentage / 100) : 0;
}

export function calculateTotalValue(rsu: Tranch, stockPrice: number) {
  return (calculateAwardsVestedToDate(rsu) + calculateAwardsUnvestedToDate(rsu)) * stockPrice;
}

export function calculateAwardsUnvestedToDateSum(tranches: Tranch[]) {
  let sum = 0;
  tranches.forEach((item) => (sum += calculateAwardsUnvestedToDate(item)));
  return sum;
}

export function calculateTotalValueSum(tranches: Tranch[], stockPrice: number) {
  let sum = 0;
  tranches.forEach((item) => (sum += calculateTotalValue(item, stockPrice)));
  return sum;
}

export function calculateAwardsVestedToDateSum(tranches: Tranch[]) {
  let sum = 0;
  tranches.forEach((item) => (sum += calculateAwardsVestedToDate(item)));
  return sum;
}

export const onRowPreparedNeedToDiscussWithClient = (e: RowPreparedEvent) => {
  if (e.data?.needToDiscussWithClient) {
    e.rowElement.style.outline = "1px solid red";
    e.rowElement.style.border = "1px solid red";
  }
};
